import { useQuery } from 'react-query';
import { getJoinedCompetitions } from 'api/services/competitions';
import { auth, useAuthState } from 'api/services/firebase';
import useAccountStore from 'store/accountStore';

const useJoinedCompetitions = () => {
  const [user] = useAuthState(auth);
  const isUserAvailable = !!user;

  const joinedCompetitions = useAccountStore(
    (state) => state.accountCompetitions.competitions,
  );

  const isLoading = useAccountStore(
    (state) => state.accountCompetitions.isLoading,
  );
  const setJoinedCompetitions = useAccountStore(
    (state) => state.setJoinedCompetitions,
  );

  useQuery({
    queryKey: 'getJoinedCompetitions',
    queryFn: getJoinedCompetitions(),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: user && !joinedCompetitions && !isLoading,
    enabled: isUserAvailable,
    retry: false,
    onSuccess: (responseData) => {
      setJoinedCompetitions(responseData?.competitionsList || [], false);
    },
    onError: () => {
      setJoinedCompetitions(null, false);
    },
  });
};

export default useJoinedCompetitions;
